<script setup>
import { ref, defineProps, defineModel, onMounted } from "vue";

const globalConfiguration = defineModel();
const props = defineProps({
  subConfig: Boolean,
  globalConfig: Object,
  loading: Boolean,
  readOnlyMode: Boolean,
});
const fields = [
  "EnableNotifications",
  "NotificationFrequency",
  "NotificationFrequencyPostDeadline",
];

function updateInherit(key) {
  if (props.readOnlyMode) {
    return;
  }
  // Check if the value exists in the global configuration
  if (!globalConfiguration.value["inherit" + key]) {
    globalConfiguration.value["inherit" + key] = true;
  } else {
    globalConfiguration.value["inherit" + key] = false;
  }
  globalConfiguration.value[key] = props.globalConfig[key];
}

onMounted(() => {
  if (!props.subConfig) {
    return;
  }
  console.log("On mounted");
  fields.forEach((field) => {
    console.log("Field", field);
    console.log("Global config", globalConfiguration.value);
    const inheritKey = "inherit" + field;
    try {
      if (globalConfiguration.value[inheritKey] === false) {
        console.log("Inherit key is false", inheritKey);
        return;
      }
    } catch (error) {
      console.log("Does not exist", inheritKey);
    }

    globalConfiguration.value[inheritKey] = true;
    globalConfiguration.value[field] = props.globalConfig[field];
  });
});
</script>

<template>
  <v-row class="ml-n5 mt-n5">
    <v-col cols="12">
      <h3>Notifications</h3>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="auto" v-if="props.subConfig">
      <v-sheet class="d-flex align-center justify-center" height="100%">
        <v-icon
          class=""
          @click="updateInherit('EnableNotifications')"
          size="x-large"
          >{{
            globalConfiguration.inheritEnableNotifications
              ? "mdi-lock-outline"
              : "mdi-lock-open-variant-outline"
          }}</v-icon
        >
      </v-sheet>
    </v-col>
    <v-col cols="6">
      <div class="font-weight-bold">Enable Notifications</div>
      <div class="text-body-2 font-weight-light text-medium-emphasis">
        Enable Apple notifications that an update is available
      </div>
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="auto">
      <v-switch
        :loading="props.loading"
        :disabled="globalConfiguration.inheritEnableNotifications"
        :label="globalConfiguration.EnableNotifications ? 'On' : 'Off'"
        color="primary"
        v-model="globalConfiguration.EnableNotifications"
        :readonly="props.readOnlyMode"
      ></v-switch>
    </v-col>
  </v-row>
  <v-divider></v-divider>
  <v-row class="pt-3">
    <v-col cols="auto" v-if="props.subConfig">
      <v-sheet class="d-flex align-center justify-center" height="100%">
        <v-icon
          class=""
          @click="updateInherit('NotificationFrequency')"
          size="x-large"
          >{{
            globalConfiguration.inheritNotificationFrequency
              ? "mdi-lock-outline"
              : "mdi-lock-open-variant-outline"
          }}</v-icon
        >
      </v-sheet>
    </v-col>
    <v-col cols="6">
      <div class="font-weight-bold">Notification Frequency</div>
      <div class="text-body-2 font-weight-light text-medium-emphasis">
        Frequency of notifications in hours from the release date until the
        deadline.
      </div>
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="4">
      <v-number-input
        :loading="props.loading"
        :disabled="globalConfiguration.inheritNotificationFrequency"
        class="pt-3"
        label="Number of hours"
        variant="outlined"
        v-model="globalConfiguration.NotificationFrequency"
        persistent-placeholder
        :min="0"
        control-variant="split"
        :readonly="props.readOnlyMode"
      ></v-number-input>
    </v-col>
  </v-row>
  <v-divider></v-divider>
  <v-row class="pt-3">
    <v-col cols="auto" v-if="props.subConfig">
      <v-sheet class="d-flex align-center justify-center" height="100%">
        <v-icon
          class=""
          @click="updateInherit('NotificationFrequencyPostDeadline')"
          size="x-large"
          >{{
            globalConfiguration.inheritNotificationFrequencyPostDeadline
              ? "mdi-lock-outline"
              : "mdi-lock-open-variant-outline"
          }}</v-icon
        >
      </v-sheet>
    </v-col>
    <v-col cols="6">
      <div class="font-weight-bold">Frequency post deadline</div>
      <div class="text-body-2 font-weight-light text-medium-emphasis">
        Frequency in minutes a notification is given after the deadline has
        passed before the app is force quit.
      </div>
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="4">
      <v-number-input
        :loading="props.loading"
        :disabled="globalConfiguration.inheritNotificationFrequencyPostDeadline"
        class="pt-3"
        label="Number of minutes"
        variant="outlined"
        v-model="globalConfiguration.NotificationFrequencyPostDeadline"
        persistent-placeholder
        control-variant="split"
        :min="0"
        :readonly="props.readOnlyMode"
      ></v-number-input>
    </v-col>
  </v-row>
</template>
